// extracted by mini-css-extract-plugin
export default {"scape":"ScapeList_scape__omtEr","isLive":"ScapeList_isLive__ohByZ","playerList":"ScapeList_playerList__7P19H"};